export const RTP_MIN_VALUE = 0.7;
export const RTP_MAX_VALUE = 0.95;
export const RTP_UNSETTLED_VALUE = RTP_MIN_VALUE;
export const RTP_MEDIAN_VALUE = Math.floor((RTP_MIN_VALUE + RTP_MAX_VALUE) / 2);
